import React from 'react';

interface EmptyChartProps {
  title: string;
  message: string;
  iconComponent?: React.ReactNode;
}

export const EmptyChart = React.forwardRef<HTMLDivElement, EmptyChartProps>(
  ({ title, message, iconComponent }, ref) => (
    <div ref={ref} className="flex flex-col items-center justify-center p-8 h-64">
      <div className="flex flex-col items-center gap-3 text-center max-w-xs">
        {iconComponent && <div className="mb-2 text-[#e5e8eb]">{iconComponent}</div>}
        <div className="font-medium text-[12px] leading-5 text-[#16282d]">{title}</div>
        <div className="font-normal text-[12px] leading-5 text-[#5d6974]">{message}</div>
      </div>
    </div>
  ),
);

EmptyChart.displayName = 'EmptyChart';
